// libs
import { useState } from "react";
import { Package, Check } from "lucide-react";

// components
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";

// custom hooks
import useProducts from "../../hooks/useProducts";
import useToken from "../../hooks/useToken";
import useAlert from "../../hooks/useAlert";

// utils
import API from "../../utils/api";

// styles
import classes from "./styles.module.css";

export default function CreateProduct({ onCloseModal }) {
  const { addProduct } = useProducts();
  const [isBtnDisabled, setIsButtonDisabled] = useState(false);
  const [title, setTitle] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [token] = useToken();
  const { createAlert } = useAlert();

  const onAddProduct = () => {
    const data = {
      title,
      purchase_price: purchasePrice,
      selling_price: sellingPrice,
    };

    if (!title || !purchasePrice || !sellingPrice) {
      return createAlert.warning("Есть пустые поля");
    }

    setIsButtonDisabled(true);
    API.postToken("/products/create", data, token)
      .then((d) => {
        if (d.status === 200) {
          addProduct(d.data?.productData);
          setTitle("");
          setPurchasePrice("");
          setSellingPrice("");
          onCloseModal();
          createAlert.success("Товар добавлен");
        } else {
          createAlert.error(
            d?.data?.message ?? "Товар не добавлен. Попробуй позже",
          );
        }
      })
      .finally(() => {
        setIsButtonDisabled(false);
      });
  };

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.headText}>
            <Package stroke="#009966" size={19} />
            <p>новый товар</p>
          </div>

          <CustomButton
            onClick={onCloseModal}
            className={classes.closeModalButton}
          >
            закрыть
          </CustomButton>
        </div>

        <div className={classes.hr}></div>

        <div className={classes.inputs}>
          <CustomInput
            className={`${classes.input} ${classes.titleInput}`}
            placeholder="Название товара"
            value={title}
            setValue={setTitle}
          />

          <CustomInput
            className={`${classes.input} ${classes.purchaseInput}`}
            placeholder="Цена закупки товара"
            value={purchasePrice}
            setValue={setPurchasePrice}
          />

          <CustomInput
            className={`${classes.input} ${classes.sellInput}`}
            placeholder="Цена продажи товара"
            value={sellingPrice}
            setValue={setSellingPrice}
          />
        </div>

        <CustomButton
          className={classes.submitButton}
          disabled={isBtnDisabled}
          onClick={onAddProduct}
        >
          <Check size={17} />
          Создать товар
        </CustomButton>
      </div>
    </div>
  );
}
